import BasePage, { BasePageProps, BasePageState, basePageInitialState } from "./BasePage"

import { isNotValidScadenzaPolizza } from "../libs/validation/dateValidation"
import { isEmpty } from "../libs/validation/stringRegex"
import { annoRistrutturazioneValidation } from "../libs/validation/dateValidation"

type AddressState = {
    indirizzo: string | undefined
    street: string | undefined
    street_number: string | undefined
    zip: string | undefined
    city: string | undefined
 
    indirizzoError: string | undefined
    streetError: string | undefined
    street_numberError: string | undefined
    zipError: string | undefined
    cityError: string | undefined

    is_manual_address: boolean
}

type BuildingState = {
    metri_quadri: number | undefined
    tipo_uso: string | undefined
    tipo_immobile: string | undefined
    numero_piani: number | undefined
    piano_abitazione: number | undefined

    anno_costruzione: string | undefined
    isRistrutturato: boolean | undefined
    anno_ristrutturazione: number | undefined

    valore_perizia: number | undefined

    metri_quadriError: string | undefined
    tipo_usoError: string | undefined
    tipo_immobileError: string | undefined
    numero_pianiError: string | undefined
    piano_abitazioneError: string | undefined

    anno_costruzioneError: string | undefined
    isRistrutturatoError: string | undefined
    anno_ristrutturazioneError: string | undefined

    valore_periziaError: string | undefined

    anni: any
    utilizzi: any
    tipologie: any
}

export type PageWithBuildingState = AddressState & BuildingState & BasePageState

export const buildingInitialState : PageWithBuildingState = {
    ...basePageInitialState,
    ...{
        metri_quadri: undefined,
        tipo_uso: undefined,
        tipo_immobile: undefined,
        numero_piani: undefined,
        piano_abitazione: undefined,

        anno_costruzione: undefined,
        isRistrutturato: undefined,
        anno_ristrutturazione: undefined,

        indirizzo: undefined,
        street: undefined,
        street_number: undefined,
        zip: undefined,
        city: undefined,

        is_manual_address: false,

        valore_perizia: undefined,

        metri_quadriError: undefined,
        tipo_usoError: undefined,
        tipo_immobileError: undefined,
        numero_pianiError: undefined,
        piano_abitazioneError: undefined,

        anno_costruzioneError: undefined,
        isRistrutturatoError: undefined,
        anno_ristrutturazioneError: undefined,

        indirizzoError: undefined,
        streetError: undefined,
        street_numberError: undefined,
        zipError: undefined,
        cityError: undefined,

        valore_periziaError: undefined,

        anni: undefined,
        utilizzi: undefined,
        tipologie: undefined,
    }
}

class PageWithBuilding <T extends BasePageProps, P extends PageWithBuildingState> 
    extends BasePage<T,P> {

        constructor (props: any) {
            super(props)

            this.setIndirizzo = this.setIndirizzo.bind(this)
            this.updateAll = this.updateAll.bind(this)
            this.updateStreet = this.updateStreet.bind(this)
            this.updateStreet_number = this.updateStreet_number.bind(this)
            this.updateZip = this.updateZip.bind(this)
            this.updateCity = this.updateCity.bind(this)

            this.updateAnni = this.updateAnni.bind(this)
            this.updateUtilizzi = this.updateUtilizzi.bind(this)
            this.updateTipologie = this.updateTipologie.bind(this)

            this.updateMetri_quadri = this.updateMetri_quadri.bind(this)
            this.updateTipo_uso = this.updateTipo_uso.bind(this)
            this.updateTipo_immobile = this.updateTipo_immobile.bind(this)
            this.updateNumero_piani = this.updateNumero_piani.bind(this)
            this.updatePiano_abitazione = this.updatePiano_abitazione.bind(this)
            this.updateAnno_costruzione = this.updateAnno_costruzione.bind(this)
            this.updateIsRistrutturato = this.updateIsRistrutturato.bind(this)
            this.updateAnno_ristrutturazione = this.updateAnno_ristrutturazione.bind(this)
            this.updateValore_perizia = this.updateValore_perizia.bind(this)

            this.validaeAnnoRistrutturazione = this.validaeAnnoRistrutturazione.bind(this)
            this.commonStep2Validation = this.commonStep2Validation.bind(this)
        }

        // indirizzo
        setIndirizzo () {
            if (
                    !isEmpty(this.state.street) &&
                    !isEmpty(this.state.street_number) &&
                    !isEmpty(this.state.zip) &&
                    !isEmpty(this.state.city)
            ) {
                const completeAddress = this.state.street + ', ' +
                    this.state.street_number + ', ' +
                    this.state.zip + ' ' +
                    this.state.city + ', ITALIA'

                this.saveStateAndRedux ({
                    indirizzo: completeAddress,
                    indirizzoError: undefined,
                    streetError: undefined,
                    street_numberError: undefined,
                    zipError: undefined,
                    cityError: undefined,
                })
            }
        }

        updateAll (
            pStreet: string | undefined | null,
            pStreet_number: string | undefined | null,
            pZip: string | undefined | null,
            pCity: string | undefined | null
        ) {
            this.setState({
                street: (pStreet === null) ? undefined : pStreet?.toUpperCase(),
                street_number: (pStreet_number === null) ? undefined : pStreet_number,
                zip: (pZip === null) ? undefined : pZip,
                city: (pCity === null) ? undefined : pCity,
            }, () => {
                this.setIndirizzo()
            })
        }
        
        updateStreet (val: string | undefined) {
            this.setState({
                street: val?.toUpperCase(),
                streetError: undefined
            }, () => {
                this.setIndirizzo()
            })
        }
        updateStreet_number (val: string | undefined) {
            this.setState({
                street_number: val,
                street_numberError: undefined
            }, () => {
                this.setIndirizzo()
            })
        }
        updateZip (val: string | undefined) {
            this.setState({
                zip: val,
                zipError: undefined
            }, () => {
                this.setIndirizzo()
            })
        }
        updateCity (val: string | undefined) {
            this.setState({
                city: val,
                cityError: undefined
            }, () => {
                this.setIndirizzo()
            })
        }

        // stabile
        updateAnni (resp: any) {
            this.setState ({
                anni: resp
            })
        }
        updateUtilizzi (resp: any) {
            this.setState ({
                utilizzi: resp
            })
        }
        updateTipologie (resp: any) {
            this.setState ({
                tipologie: resp
            })
        }

        updateMetri_quadri (val: number | undefined) {
            this.saveStateAndRedux({
                metri_quadri: val,
                metri_quadriError: undefined
            })
        }
        updateTipo_uso (val: string | undefined) {
            this.saveStateAndRedux({
                tipo_uso: val,
                tipo_usoError: undefined
            })
        }
        updateTipo_immobile (val: string | undefined) {
            this.saveStateAndRedux({
                tipo_immobile: val,
                tipo_immobileError: undefined,
                /*
                numero_piani: (val !== 'appartamento') ? undefined : this.state.numero_piani,
                piano_abitazione: (val !== 'appartamento') ? undefined : this.state.piano_abitazione
                */
            })
        }
        updateNumero_piani (val: number | undefined) {
            this.saveStateAndRedux({
                numero_piani: val,
                numero_pianiError: undefined
            })
        }
        updatePiano_abitazione (val: number | undefined) {
            this.saveStateAndRedux({
                piano_abitazione: val,
                piano_abitazioneError: undefined
            })
        }
        updateAnno_costruzione (val: string | undefined) {
            this.saveStateAndRedux({
                anno_costruzione: val,
                anno_costruzioneError: undefined
            })
        }
        updateIsRistrutturato (val: boolean) {
            let next = {
                isRistrutturato: val,
                isRistrutturatoError: undefined
            }
            if (val === false) {
                next = {
                    ...next,
                    ...{ anno_ristrutturazione: undefined, anno_ristrutturazioneError: undefined }
                }
            }
            this.saveStateAndRedux( next )
        }
        updateAnno_ristrutturazione (val: number | undefined) {
            this.saveStateAndRedux ({
                anno_ristrutturazione: val,
                anno_ristrutturazioneError: undefined
            })
        }

        updateValore_perizia (val: number | undefined) {
            this.saveStateAndRedux({
                valore_perizia: val,
                valore_periziaError: undefined
            })
        }

        validaeAnnoRistrutturazione () {
            return annoRistrutturazioneValidation (
                this.state.isRistrutturato,
                this.state.anno_costruzione,
                this.state.anno_ristrutturazione
            )
        }

        commonStep2Validation (validateValue?: boolean) {
            let error = undefined 

            if (this.state.polizzaAttiva === undefined) {
                error = 'POLIZZA'
            }
            else if (
                this.state.polizzaAttiva === true && 
                isNotValidScadenzaPolizza(this.state.scadenzaPolizza)
            ) {
                error = 'SCADENZA_POLIZZA'
            }
            
            else if (this.state.metri_quadri === undefined || Number(this.state.metri_quadri) <= 0) {
                error = 'METRI_QUADRI'
            }
            else if (isEmpty( this.state.tipo_uso )) {
                error = 'TIPO_USO'
            }
            else if (isEmpty( this.state.tipo_immobile )) {
                error = 'TIPO_IMMOBILE'
            }
            else if (
                this.state.numero_piani === undefined || Number(this.state.numero_piani) < 0 ||
                (
                    this.state.piano_abitazione !== undefined && 
                    Number(this.state.piano_abitazione) > Number(this.state.numero_piani)
                )
            ) {
                error = 'NUMERO_PIANI'
            }
            else if (
                this.state.piano_abitazione === undefined || Number(this.state.piano_abitazione) < 0 ||
                (
                    this.state.numero_piani !== undefined && 
                    Number(this.state.piano_abitazione) > Number(this.state.numero_piani)
                )
            ) {
                error = 'PIANO_ABITAZIONE'
            }
            else if (isEmpty( this.state.anno_costruzione )) {
                error ='ANNO_COSTRUZIONE'
            }
            else if (this.state.isRistrutturato === undefined) {
                error = 'IS_RISTRUTTURATO'
            }
            else if (
                (this.state.isRistrutturato === true && this.state.anno_ristrutturazione === undefined) ||
                (
                    this.state.anno_ristrutturazione !== undefined &&
                    this.validaeAnnoRistrutturazione() !== undefined
                )
            ) {
                error = 'ANNO_RISTRUTTURAZIONE'
            }
            else if (this.state.indirizzo === undefined) {
                error = 'INDIRIZZO'
            }

            else if (validateValue === true && (this.state.valore_perizia === undefined || Number(this.state.valore_perizia) <= 0)) {
                error ='VALORE_PERIZIA'
            }

            /*
            DEVE ESSERE VALIDATA PER ULTIMA LA LASCIO NEL COMPONENT FIGLIO!!

            else if (isValidPrivacy( this.state.noMotorPrivacy, this.state.user !== undefined)) {
                error = 'PRIVACY'
            }
            */
            
            return error
        }

}

export default PageWithBuilding